import OrderLog from './log'
import OrderOverview from './overview'
module.exports = {
  OrderLog,
  OrderOverview
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/orders/index.js